import { createStyleSheet } from '@shared-ui/theme'
import { rh, rw } from '@shared-ui/theme/scale'

export const useCreateStyles = createStyleSheet((theme) => ({
  root: { flex: 1, minHeight: 0, backgroundColor: theme.COLOR_BG_BASE },
  content: { flex: 1, minHeight: 0 },
  overlay: {
    position: 'absolute',
    inset: 0,
    zIndex: 10000,
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    // COLOR_NEUTRAL_50 всегда #fff — на тёмной теме давал белую вспышку после static-splash.
    backgroundColor: theme.COLOR_BG_BASE,
  },
  markStage: { width: rw(220), height: rw(170), marginTop: -rh(32) },
  markLight: { position: 'absolute', inset: 0 },
}))
